module.exports = __webpack_public_path__ + "img/invoice-de-male-bb.25256936.png";